import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FormControl } from '@angular/forms';
import { GruposService, Usuario } from 'src/app/services/admin/grupos/grupos.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-grupo-usuarios',
  templateUrl: './grupo-usuarios.component.html',
  styleUrls: ['./grupo-usuarios.component.scss']
})
export class GrupoUsuariosComponent implements OnInit {

  @Input() grupoId: number;
  @Output() guardar = new EventEmitter<string[]>();
  @Output() cancelar = new EventEmitter<void>();

  loading = false;
  saving = false;
  searchControl = new FormControl('');
  usuarios: Usuario[] = [];
  usuariosFiltrados: Usuario[] = [];
  usuariosSeleccionados: string[] = [];

  constructor(private gruposService: GruposService) { }

  ngOnInit(): void {
    this.cargarUsuarios();
    this.setupSearch();
  }

  cargarUsuarios(): void {
    this.loading = true;
    this.gruposService.getUsuariosDisponibles(this.grupoId).subscribe(
      (response: any) => {
        this.usuarios = response.data || [];
        this.usuariosFiltrados = [...this.usuarios];
        this.usuariosSeleccionados = this.usuarios
          .filter(u => u.isAssigned)
          .map(u => u.usuario);
        this.loading = false;
      },
      (error) => {
        console.error('Error cargando usuarios:', error);
        Swal.fire('Error', 'No se pudieron cargar los usuarios', 'error');
        this.loading = false;
      }
    );
  }

  setupSearch(): void {
    this.searchControl.valueChanges.subscribe(searchValue => {
      this.filtrarUsuarios(searchValue);
    });
  }

  filtrarUsuarios(search: string): void {
    const searchLower = search?.toLowerCase() || '';
    this.usuariosFiltrados = this.usuarios.filter(usuario =>
      usuario.usuario.toLowerCase().includes(searchLower) ||
      usuario.nombre.toLowerCase().includes(searchLower)
    );
  }

  isAllSelected(): boolean {
    const numSelected = this.usuariosSeleccionados.length;
    const numRows = this.usuariosFiltrados.length;
    return numSelected > 0 && numSelected === numRows && numRows > 0;
  }

  toggleAllRows(): void {
    if (this.isAllSelected()) {
      this.usuariosSeleccionados = this.usuariosSeleccionados.filter(u =>
        !this.usuariosFiltrados.find(uf => uf.usuario === u)
      );
    } else {
      const noSeleccionados = this.usuariosFiltrados
        .filter(u => !this.usuariosSeleccionados.includes(u.usuario))
        .map(u => u.usuario);
      this.usuariosSeleccionados = [...this.usuariosSeleccionados, ...noSeleccionados];
    }
  }

  toggleUsuario(usuario: Usuario): void {
    const index = this.usuariosSeleccionados.indexOf(usuario.usuario);
    if (index > -1) {
      this.usuariosSeleccionados.splice(index, 1);
    } else {
      this.usuariosSeleccionados.push(usuario.usuario);
    }
  }

  isUsuarioSeleccionado(usuario: Usuario): boolean {
    return this.usuariosSeleccionados.includes(usuario.usuario);
  }

  guardarUsuarios(): void {
    this.saving = true;

    // Preparar el array de usuarios con estructura requerida
    const usuariosData = this.usuariosSeleccionados.map(usuario => ({
      usuario,
      miniadmin: false
    }));

    this.gruposService.saveUsuarios(this.grupoId, usuariosData).subscribe(
      (response: any) => {
        Swal.fire('Éxito', response.message || 'Usuarios asignados correctamente', 'success');
        this.saving = false;
        this.guardar.emit(this.usuariosSeleccionados);
      },
      (error) => {
        console.error('Error guardando usuarios:', error);
        Swal.fire('Error', error?.error?.message || 'Error al guardar usuarios', 'error');
        this.saving = false;
      }
    );
  }

  cancelarForm(): void {
    this.cancelar.emit();
  }
}
